module.exports = "/red-close5367b641ac03b3b2346cfd1a5caa0723.svg";